import { ShieldCheck } from "lucide-react";

export default function CommandFooter() {
  return (
    <footer
      className="border-t border-white/5 bg-black/60"
      data-testid="command-footer"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-md border border-gold/40 grid place-items-center bg-black">
            <ShieldCheck className="w-4 h-4 text-gold" strokeWidth={1.6} />
          </div>
          <div className="leading-tight">
            <div className="font-heading text-sm tracking-[0.18em] text-white">
              SOVEREIGN LIFESTYLE HUB
            </div>
            <div className="font-mono text-[9px] tracking-[0.3em] text-white/45 uppercase">
              Nessa Rescue Node · Vol 0
            </div>
          </div>
        </div>

        <div className="flex items-center gap-5 font-mono text-[10px] tracking-[0.24em] uppercase text-white/45">
          <span data-testid="footer-status">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-violet animate-pulse-violet mr-2 align-middle" />
            Node Operational
          </span>
          <span className="hidden sm:inline">·</span>
          <span>© 2026 Sovereign Lifestyle Hub</span>
        </div>
      </div>
    </footer>
  );
}
